module.exports = {
    'MobileMenu': require('./mobile-menu'),
    'MenuLinks': require('./menu-links'),
    'StickyHeader': require('./sticky-header'),
};